import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { hydrateAccountFromToken } from "@/lib/store";

export default function MagicLinkPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"loading" | "success" | "error">(
    "loading"
  );

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    if (hash) {
      const params = new URLSearchParams(hash);
      const accessToken = params.get("accessToken");
      const refreshToken = params.get("refreshToken");

      if (accessToken && refreshToken) {
        localStorage.setItem("access_token", accessToken);
        localStorage.setItem("refresh_token", refreshToken);
        hydrateAccountFromToken();
        setStatus("success");
        const redirect = searchParams.get("redirect") || "/trips";
        setTimeout(() => {
          window.location.href = redirect;
        }, 500);
        return;
      }
    }

    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
    }
  }, [searchParams]);

  return (
    <div className="flex min-h-[72vh] items-center justify-center px-4">
      <div className="rounded-2xl frost-panel px-8 py-6 text-center">
        {status === "loading" && <p className="text-ink-light">Verifying...</p>}
        {status === "success" && (
          <p className="font-semibold text-electric">Verified. Redirecting...</p>
        )}
        {status === "error" && (
          <p className="font-semibold text-red-300">Invalid or expired link</p>
        )}
      </div>
    </div>
  );
}
